

const Main = () => {


  return (
    <div className="min-h-screen bg-neutral-50">
      <div className="mx-auto max-w-[1280px] bg-white rounded-2xl shadow-[0_0_0_1px_rgba(0,0,0,0.06),0_40px_80px_-24px_rgba(0,0,0,0.12)] overflow-hidden">
        <div className="flex">
          {/* Left Nav */}


          {/* Right content */}
          <div className="flex-1 min-w-0">
            <main className="p-8">
              <h1 className="text-xl font-bold">CMS 메인</h1>
              {/* 필요 시 추가 내용 */}
            </main>
          </div>
        </div>
      </div>


    </div>
  );
};

export default Main;
